import { useEffect, useRef, useState } from 'react';

const COUNTDOWN_MINUTES = 15;
const COUNTDOWN_SECONDS = COUNTDOWN_MINUTES * 60;

function formatCountdownTime(seconds: number) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

export function useCheckoutFormCountdown(isOpen: boolean, isSubmitted: boolean) {
  const [timeRemaining, setTimeRemaining] = useState(COUNTDOWN_SECONDS);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const startTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isOpen || isSubmitted) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      startTimeRef.current = null;
      setTimeRemaining(COUNTDOWN_SECONDS);
      return;
    }

    startTimeRef.current = Date.now();
    setTimeRemaining(COUNTDOWN_SECONDS);

    intervalRef.current = setInterval(() => {
      if (startTimeRef.current) {
        const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
        const remaining = Math.max(0, COUNTDOWN_SECONDS - elapsed);
        setTimeRemaining(remaining);

        if (remaining === 0 && intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isOpen, isSubmitted]);

  const isTimeLow = timeRemaining < 300;
  return { timeRemaining, isTimeLow, formatTime: formatCountdownTime };
}
